import { InventorySearchEvents } from '@dealersites/inventory/events';
// TO DO: modify to target the button that leads to the modal
/**
 * @file
 * Customize the behavior of the SRP search filters.
 */
document.addEventListener('DOMContentLoaded', function () {
  const dspFilters = document.getElementById('dsp-filters');

  if (dspFilters) {
    // Hide any empty filters on page load.
    for (const container of dspFilters.querySelectorAll(`[data-option-count="0"]`)) {
      const filterVisbility = container.closest('.filter-visibility');
      const fallback = filterVisbility.querySelector('.filters__no-options');
      if (fallback) {
        fallback.classList.remove('inactive');
        container.classList.add('inactive');
      } else {
        filterVisbility.classList.add('inactive');
      }
    }

    // Adjust fallback text visibility as the data changes OR hide/show exposed filter
    dspFilters.addEventListener(InventorySearchEvents.POST_SEARCH_FILTER_UPDATE, (e) => {
      const { filter } = e.detail;
      const { container } = filter;

      if (!'optionCount' in container.dataset) {
        return;
      }

      const optionCount = Number.parseInt(container.dataset.optionCount);
      const filterVisbility = container.closest('.filter-visibility');
      const fallback = filterVisbility.querySelector('.filters__no-options');

      let isHidden = false;
      const shouldShowFallback = optionCount < 1;

      if (fallback) {
        isHidden = fallback.classList.contains('inactive');
        if (shouldShowFallback && isHidden) {
          fallback.classList.remove('inactive');
          container.classList.remove('inactive');
        } else if (!shouldShowFallback && !isHidden) {
          fallback.classList.add('inactive');
          container.classList.add('inactive');
        }
      } else {
        if (shouldShowFallback) {
          filterVisbility.classList.add('inactive');
        } else {
          filterVisbility.classList.remove('inactive');
        }
      }
    });
  }
});
